<template>
  <div>
    <div id="build-section"></div>
    <AboutBanner v-if="$route.path==='/sub/light-blocks/technical/build-structure'" :content="banners[0].details"
                 :title="banners[0].title" :img="banners[0].photo_file"/>
    <AboutTitle title="نحوه اجرای بلوک سبک" page-route="/sub/light-blocks/technical/build-structure"/>
    <v-row class="w-80 mx-auto my-16">
      <v-col cols="12" sm="12" md="6" xl="6" lg="6" class="pl-2">
        <div v-for="(item,index) in rightHalf" :key="index">
          <div class="expanded-box px-2"
               @click="expandManage(index,true)"
          >
            <h4 class="pt-4 white--text">{{item.index+' - '+ item.title }}</h4>
            <v-icon color="white">mdi-plus</v-icon>
          </div>
          <div v-html="item.details" class="content-box" v-if="expandedItemRight===index">

          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="6" lg="6" class="pr-2">
        <div v-for="(item,index) in leftHalf" :key="index">
          <div class="expanded-box px-2"
               @click="expandManage(index,false)"
          >
            <h4 class="pt-4 white--text">{{item.index+' - '+ item.title }}</h4>
            <v-icon color="white">mdi-plus</v-icon>
          </div>
          <div v-html="item.details" class="content-box" v-if="expandedItemLeft===index">

          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapState} from "vuex";
import AboutTitle from "../../About/Components/AboutTitle";
import AboutBanner from "../../About/Components/AboutBanner";

export default {
  name: "BuildStructure",
  components: {AboutBanner, AboutTitle},
  data() {
    return {
      expandedItemRight: null,
      expandedItemLeft: null,
      rightHalf: [
        {
          index:1,
          title: 'حمل و نگهداری ',
          details: 'تخلیه بلوک با وسایل مناسب نظیر لیفتراک انجام گردد. در صورت جدا شدن پالت ها از یکدیگر، احتمال آسیب دیدن گوشه‌ها وجود دارد. بلوک‌ها روی یک سطح صاف و بالاتر از زمین تخلیه و نگهداری شوند. در صورت تخلیه روی سقف، در سطح نزدیک ستون و دیوارها توزیع گردد.\n' +
              'در صورت وجود پوشش بر روی پالت، یک روز قبل از مصرف بلوک‌ها، پوشش برداشته شود تا تبادل رطوبتی و حرارتی با محیط اجرا انجام گردد. در پایان روزکاری، روی سطح بلوک‌های باقیمانده با نایلون پوشانده شود. \n' +
              'کیسه‌های ملات باید بر روی کف خشک با حداقل فاصله 10 سانتیمتر از زمین قرار گیرند و در معرض بارنگی قرار نداشته باشند و حداکثر تعداد 8 عدد کیسه را می‌توان روی‌هم قرارداد.\n'
        },
        {
          index:3,
          title: 'نصب بلوک های ردیف اول',
          details: 'رج اول با کنترل دقیق تراز و در یک راستا اجرا گردد. ابتدا امتدادهای اصلی و سپس تقاطع‌ها کار شود. در زیر کار (محل چیدن بلوک‌های دیوار)، با استفاده از ملات ماسه سیمان سطح صاف و تراز به ضخامت 1 تا 5/2 سانتیمتر، ایجاد گردد. در دیوارهای همکف (در فاصله کمتر از 30 سانتیمتر از سطح خاک) قبل از اجرای ملات یک‌لایه عایق رطوبتی اجرا شود. پس از نصب هر بلوک سطح آن با برس تمیز شود و سپس به سطح عمودی چسب بلوک زده می‌شود . حداقل ضخامت چسب 2 میلی‌متر و حداکثر 3 میلی‌متر هست.\n' +
              'برای اجرای چسب از ماله یا کاردک دندانه درا استفاده شود. بعد از نصب هر بلوک تراز بودن آن چک شود. اصلاح کردن با ضربات آهسته چکش لاستیکی حداکثر در مدت‌زمان 5 دقیقه امکان‌پذیر است. برای جلوگیری از اثرات میان قابی در هنگام وقوع زلزله و اثرات انبساط و انقباض، دیوارها بافاصله حداقل یک سانتیمتر از ستون‌ها، تیرها و دیوارهای بتنی اجراشده و با تسمه‌های فلزی انعطاف‌پذیر به فاصله حداکثر سه بلوک (قائم و افقی)، به سازه متصل شوند. برای این منظور از نوارهای فلزی سوراخ‌دار در محل اتصال دیوارهای فرعی،درزها و اتصال به ستون استفاده شود. فاصله و تعداد شاخک‌های اتصال با توجه به ارتفاع سازه و نظر طراح کنترل گردد. برای پر کردن فاصله‌ها می‌توان از مصالح انعطاف‌پذیر مثل پلی یورتان،پلاستوفوم یا گچ کشته استفاده نمود.\n',
        },
        {
          index:5,
          title: 'پشت‌بند یا کلاف',
          details: 'درصورتی‌که ارتفاع دیوار از 5/3 متر بیشتر باشد باید از کلاف افقی متصل به اسکلت ساختمان استفاده نمود. درصورتی‌که طول دیوار از 6 متر و یا 40 برابر ضخامت دیوار،بیشتر باشد باید از پشت‌بند یا کلاف قائم متصل به اسکلت ساختمان استفاده شود. لبه قائم و افقی تیغه‌ها نباید آزاد باشد.',
        },
        {
          index:7,
          title: 'سوراخ‌کاری',
          details: 'سوراخ‌کاری با دستگاه برش دوار انجام شود. قطر سوراخ از یک‌سوم عمق بلوک بیشتر نشود. اطراف سوراخ بزرگ‌تر باید با توری فلزی تقویت گردد. درصورتی‌که عمق شیار از یک‌سوم عمق بلوک بیشتر باشد، باید هر دو رج با دو میلگرد هشت دو سر گونیا تقویت انجام گردد.',
        },
        {
          index:9,
          title: 'لکه‌گیری سطح دیوار',
          details: 'برای ترمیم پریدگی‌ها و لکه‌گیری می‌توان از چسب ملات بلوک استفاده نمود. قبل از اجرا سطح با برس تمیز شود. لکه‌گیری با استفاده از کاردک انجام می‌شود. سپس سطح با یک سوهان ریز یا سمباده صاف و آماده رنگ‌آمیزی می‌شود.',
        },
        {
          index:11,
          title: 'نازک‌کاری ',
          details: 'با توجه به سطح صاف می‌توان دیوار را با اجرای کاغذدیواری، لایه‌نازک گچ، پلاستر سیمان، سرامیک، پوشش‌های طرحدار آکریلیک یا ملات آماده پوشش داد. قبل از نازک‌کاری و نماسازی غیر خشک، سطح بلوک‌ها به‌طور کامل تمیز و سپس مرطوب گردد.\n' +
              'در محل ناپیوستگی دیوارها(گوشه‌ها،کنار بازشوها و....)می‌توان از مش‌های فایبرگلاس استفاده کرد. حداقل زمان عمل‌آوری پلاستر و سطوحی که با ملات ماسه سیمان اجراشده‌اند 3 روز است که سطح دیوار باید مرطوب نگه‌داشته شود.\n' +
              'در محل اتصال مصالح در نما (مانند محل اتصال بلوک AAC با دیوار برشی بتن آرمه یا اسکلت بتنی و فلزی)، از رابیتس (با جهت تسمه افقی)استفاده شود.  در ساختمان‌های صنعتی و پارکینگ‌ها می‌توان بلوک‌های AAC را به‌طور مستقیم بارنگ آکریلیک رنگ‌آمیزی نمود.\n',
        },
      ],
      leftHalf: [
        {
          index:2,
          title: 'آماده‌سازی چسب بلوک ',
          details: 'نوع چسب بلوک AAC و یا همان ملات مربوطه می‌بایست خواسته‌های استاندارد ملی ایران به شماره 706 را تأمین نماید. چسب فوق بر اساس دستورالعمل مندرج بر روی پاکت، در داخل ظرف پلاستیکی مناسبی مانند سطل ریخته شده و با آب تمیز (آب شرب) مخلوط می‌گردد.\n' +
              ' توصیه می‌شود جهت اختلاط از روش مکانیزه استفاده شود و اختلاط تا زمان حذف هوا ادامه یابد. لذا جهت این امیر می‌توان از همزن مربوطه که بر روی دریل بسته می‌شود استفاده نمود و عمل اختلاط را با سرعت کم تا رسیدن به نتیجه مطلوب انجام داد.\n' +
              'قابل‌ذکر است عمر کارایی ملات ها مشخص و عموماً بین 4 تا 5 ساعت می‌باشد. بدین ترتیب در ساخت ملات می‌بایست دقت شود تا ملات اضافی ساخته نشود که در این حالت نمی‌توان پس از سفت شدن به آن آب اضافه و مجدد استفاده نمود.\n',
        },
        {
          index:4,
          title: 'نصب بلوک‌ها در ردیف بعد',
          details: 'در زمان اجرا، سطح بلوک‌ها باید مرطوب باشد. برای اجرای بلوک‌های بعدی باید سطوح عمودی و افقی با ماله دندانه‌دار چسب زده و قبل از چسب زدن سطح بلوک‌ها با برس تمیز شود.\n' +
              'در هنگام نصب بلوک ابتدا لبه، دور از اتصال بلوک گذاشته و سپس قسمت اتصال در محل خود قرار گیرد. از لغزاندن بلوک خودداری و ملات های اضافی با کاردک تمیز شود.کاردک به‌صورت 45 درجه نسبت به بلوک قرار گیرد و حرکت به‌گونه‌ای باشد که لبه تیز به سمت درز نباشد.هم‌پوشانی بلوک‌ها باید حداقل 15 سانتیمتر (حداقل فاصله درز قائم 15 سانتیمتر است) و برای هر رج باید ثابت باشد. \n' +
              'در تقاطع زاویه‌دار دیوارها، سطح فارسی بر دو وجه خارجی قرار گیرد و به‌عبارت‌دیگر درز قائم روی هم قرار نگیرد.\n' +
              'برای اجرای شاقولی دیوارها، تراز و امتداد هر بلوک پس از نصب کنترل شود. دیوار فرعی باضخامت کمتر از دیوار اصلی بافاصله اجرایی حدود 1 سانتیمتر و با استفاده از نوارهای فولادی بافاصله یک متر، به دیوار اصلی متصل می‌شوند.\n' +
              'اتصال دیوارهای فرعی L  یا T شکل که هم ضخامت باشند، به‌صورت لاریز اجرا شود.\n',
        },
        {
          index:6,
          title: 'برشکاری',
          details: 'برشکاری با اره دستی، اره نواری و لوازم تجاری به ابعاد و شکل دلخواه قابل انجام است. درصورتی‌که برش با لوازم برقی، از ماسک و لوازم ایمنی استفاده شود.',
        },
        {
          index:8,
          title: 'اجرای تأسیسات ',
          details: 'برای مسیرهای تأسیسات می‌توان شیار عمودی و سوراخ‌کاری در دیوارها اجرا نمود. بعد از اجرای تأسیسات، مسیرها و سوراخ‌های اضافی با چسب ملات بلوک پر شود.',
        },
        {
          index:10,
          title: 'نصب در و پنجره',
          details: 'نصب درب و پنجره مستقیماً بر روی بلوک ACC انجام می‌گیرد و  بهتر است برای قرارگیری چهارچوب‌های فلزی از ملات ماسه سیمان استفاده شود.',
        },

      ]
    }
  },
  methods: {
    expandManage(index, right) {
      if (right) {
        if (this.expandedItemRight === index) {
          this.expandedItemRight = null;
        } else {
          this.expandedItemRight = index;
        }
      } else {
        if (this.expandedItemLeft === index) {
          this.expandedItemLeft = null;
        } else {
          this.expandedItemLeft = index;
        }
      }

    }
  },
  created() {
    if (this.banners == null) {
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    /*    this.$store.dispatch('lightBlocksManagement/getBuildStructure').then(
            res => {
              const half = Math.ceil(res.length / 2);
              this.rightHalf = res.slice(0, half);
              this.leftHalf = res.slice(-half);
            }
        );*/
  },
  computed: {
    ...mapState({
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  }

}
</script>

<style scoped>
.expanded-box {
  height: 60px;
  margin-bottom: 12px;
  cursor: pointer;
  background: #7BAD32;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.content-box {
  height: max-content;
  padding: 0 16px;
  animation: change-height 1s ease-out;
}

@keyframes change-height {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 400px;
  }
}

</style>